import { accountClient } from "./http";

export async function getTermsVersion(): Promise<{ version: string }> {
  const { data } = await accountClient.get<{ version: string }>(`/terms/currentVersion`);
  return data;
}  
